import TimelineItemWrapper from './TimelineItemWrapper';

export default TimelineItemWrapper;
